/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthBindCodeExchangeReqVo
 */
export interface OAuthBindCodeExchangeReqVo {
    /**
     * 回调 URL 携带的一次性交接码
     * 一次性交接码
     * @type {string}
     * @memberof OAuthBindCodeExchangeReqVo
     */
    code: string;
}

/**
 * Check if a given object implements the OAuthBindCodeExchangeReqVo interface.
 */
export function instanceOfOAuthBindCodeExchangeReqVo(value: object): value is OAuthBindCodeExchangeReqVo {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function OAuthBindCodeExchangeReqVoFromJSON(json: any): OAuthBindCodeExchangeReqVo {
    return OAuthBindCodeExchangeReqVoFromJSONTyped(json, false);
}

export function OAuthBindCodeExchangeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthBindCodeExchangeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function OAuthBindCodeExchangeReqVoToJSON(json: any): OAuthBindCodeExchangeReqVo {
    return OAuthBindCodeExchangeReqVoToJSONTyped(json, false);
}

export function OAuthBindCodeExchangeReqVoToJSONTyped(value?: OAuthBindCodeExchangeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

